import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastJourneysHandoff } from '@/pages/workspaces/broadcasts/broadcast/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/journeys',
)({
  component: JourneysBroadcastJourneysHandoff,
});
